import React from 'react';

import { Link, useLocation } from 'react-router-dom';

import ErrorGif from '../assets/images/General Error.gif';
import { SafeHtml } from '../components/FormElements';
import TenantConfig from '../config';

const ErrorPage = ({ linkButtonText, linkTo, message, title, linkButton, onClick }) => {
  const location = useLocation();
  const error = location?.state;

  return (
    <div className="majorerror">
      <div className="majorerror__logo">
        <img src={TenantConfig.headerLogo} alt="logo" />
      </div>
      <div className="majorerror__divider"></div>
      <div className="majorerror__title">
        <h1>{title || error?.title}</h1>
      </div>
      <div className="majorerror__message">
        <span>
          <SafeHtml originalHtml={message} />
        </span>
      </div>
      <div className="majorerror__gif">
        <img src={ErrorGif} alt="Major Error" />
      </div>
      <div className="majorerror__button-wrapper">
        {linkButton || (
          <Link to={linkTo || error?.linkTo || '/dashboard'} onClick={onClick}>
            {linkButtonText || error?.linkButtonText || 'Dashboard'}
          </Link>
        )}
      </div>
    </div>
  );
};

export default ErrorPage;
